import { InputNumber, InputNumberProps } from 'antd';
import React from 'react';

interface IInputMoney extends InputNumberProps {
    disabled?: boolean;
}

const InputMoney: React.FC<IInputMoney> = React.forwardRef<InputNumberProps, IInputMoney>(
    ({ disabled, ...restProps }, _ref) => {
        return (
            <InputNumber
                disabled={disabled}
                addonAfter="$"
                precision={2}
                min={-999999999}
                max={999999999}
                decimalSeparator={'.'}
                {...restProps}
            />
        );
    },
);

export default InputMoney;
